// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1tKkbrsVT8gfXKHvFzDPeK {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-bottom: 1px solid #eee;\n  border-right: 1px solid #eee;\n}", ""]);
// Exports
exports.locals = {
	"Cell": "_1tKkbrsVT8gfXKHvFzDPeK"
};
module.exports = exports;
